export { ComponentLoader } from './component-loader.class';
export { ComponentLoaderFactory } from './component-loader.factory';
export { ContentRef } from './content-ref.class';



// WEBPACK FOOTER //
// ./~/angular-bootstrap-md/utils/component-loader/index.ts